import Decimal from 'decimal.js';

export const ZERO = new Decimal(0);

export const ONE = new Decimal(1);

export const HUNDRED = new Decimal(100);

export const TOLERANCE = new Decimal('0.01');
